<template>
  <div>
    <el-form
      :model="dialForm"
      :rules="rules"
      ref="dialForm"
      style="margin-right: 30px"
    >
      <!--
      <el-form-item label="项目" :label-width="formLabelWidth" prop="projectId">
        <el-select style="margin-right: 30px" v-model="dialFrom.projectId" filterable placeholder="请选择项目">
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id" :index="item.id">
          </el-option>
        </el-select>
      </el-form-item>

-->
      <el-form-item label="设备型号" :label-width="formLabelWidth" prop="model">
        <el-select
          style="margin-right: 30px"
          clearable
          v-model="dialForm.model"
          filterable
          placeholder="请选择设备型号"
        >
          <el-option
            v-for="item in modelList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :index="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="表盘名称" :label-width="formLabelWidth" prop="name">
        <el-input v-model="dialForm.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="表盘ID" :label-width="formLabelWidth" prop="dialPos">
        <el-input
          v-model="dialForm.dialPos"
          autocomplete="off"
          type="number"
          :disabled="op === 'edit'"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="预置表盘"
        :label-width="formLabelWidth"
        prop="preset"
      >
        <el-radio-group v-model="dialForm.preset">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        class="fileUpload"
        label="表盘文件"
        :label-width="formLabelWidth"
        style="height: fit-content"
        prop="file"
      >
        <el-upload
          class="file-uploader"
          ref="dfile"
          accept="bin"
          name="file"
          drag
          :auto-upload="false"
          action=""
          :on-change="selectFile"
          :limit="1"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或<em>点击上传</em>
            <!-- <br>
            每次只能上传一个文件，如需更改，先将当前文件删除，再重新选择 -->
          </div>
        </el-upload>
        <div v-if="data.fileName && !fchanged" style="margin-top: 10px">
          {{ data.fileName }}
        </div>
      </el-form-item>

      <el-form-item
        label="表盘图片"
        :label-width="formLabelWidth"
        style="height: fit-content"
        prop="picture"
      >
        <el-upload
          ref="pic"
          class="avatar-uploader"
          name="picture"
          :auto-upload="false"
          action=""
          :on-change="selectPicture"
          :show-file-list="false"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <img
            v-if="data.picture && !imageUrl"
            :src="data.picture"
            class="avatar"
          />
          <i
            v-if="!data.picture && !imageUrl"
            class="el-icon-plus avatar-uploader-icon"
          ></i>
        </el-upload>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="confirmAction('dialForm')"
            :disabled="disableSubmit"
            >确 定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
//上传OTA文件界面
import {
  createDial,
  getDialList,
  editDial,
  editDialNoUpload,
} from "../../api/dialApi";
import { handleResponse } from "../../utils/response";
import { API_URL, requestHeaders } from "../../api/request";

export default {
  name: "AddDialForm",
  props: {
    data: {
      default: {
        name: "",
        dialPos: "",
        file: null,
        picture: null,
        preset: "0",
      },
      type: Object,
    },
    op: {
      default: "add",
      type: String,
    },
  },
  watch: {
    data(newValue) {
      if (this.data.id) {
        this.data.preset = this.data.preset + "";
        this.dialForm = this.data;
      }
    },
    op(newValue) {
      if (this.op === "edit") {
        this.$refs["dialForm"].clearValidate();
        // this.$refs['dialForm'].
        this.rules = this.rEdit;
      } else {
        this.rules = this.rAdd;
      }
    },
  },
  created() {
    if (this.data.id) {
      // this.data.preset = this.data.preset.toStirng();
      this.data.preset = this.data.preset + "";
      this.dialForm = this.data;
    }
    if (this.op === "edit") {
      this.rules = this.rEdit;
    } else {
      this.rules = this.rAdd;
    }
  },
  mounted() {
    // console.log("API_URL", API_URL);
  },
  methods: {
    getDialList(page, size) {
      getDialList(page, size).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.dialList = data.list;
          },
          (error) => {}
        );
      });
    },
    closeDialog() {
      this.$emit("clickCancel");
    },
    confirmAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disableSubmit = true;
          this.submitData.set("model", this.dialForm.model);
          this.submitData.set("name", this.dialForm.name);
          this.submitData.set("dialPos", this.dialForm.dialPos);
          this.submitData.set("preset", this.dialForm.preset);
          if (this.op === "add") {
            createDial(this.submitData).then((response) => {
              handleResponse(
                response,
                (data) => {
                  this.disableSubmit = false;
                  this.$emit("successCreateDial");
                  this.$message.success("上传成功");
                },
                (error) => {
                  // this.$message('修改失败');
                  this.disableSubmit = false;
                }
              );
            });
          } else {
            if (!this.fchanged) {
              this.submitData.set("file", null);
            }
            if (!this.pchanged) {
              this.submitData.set("picture", null); //this.data.picture
            }
            this.submitData.set("model", this.data.model);
            this.submitData.set("fileName", this.data.fileName);
            this.submitData.set("id", this.data.id);
            editDial(this.submitData).then((response) => {
              handleResponse(
                response,
                (data) => {
                  this.disableSubmit = false;
                  this.$emit("successCreateDial");
                  this.$message.success("修改成功");
                },
                (error) => {
                  this.disableSubmit = false;
                }
              );
            });

            this.fchanged = false;
            this.pchanged = false;
          }
          // this.submitData = new FormData();
        } else {
          this.disableSubmit = false;
          return false;
        }
      });
    },
    clearData() {
      this.dialForm = {
        name: "",
        dialPos: "",
        file: null,
        picture: null,
        preset: "0",
      };
      this.$refs.pic.clearFiles();
      this.$refs.dfile.clearFiles();
      this.imageUrl = "";
    },
    selectFile(file) {
      this.fchanged = true;
      this.dialForm.file = file;
      this.submitData.set("file", file.raw);
    },
    selectPicture(file) {
      this.pchanged = true;
      this.dialForm.picture = file;
      this.imageUrl = URL.createObjectURL(file.raw);
      this.submitData.set("picture", file.raw);
    },
  },

  data() {
    return {
      fchanged: false,
      pchanged: false,
      imageUrl: "",
      disableSubmit: false,
      rules: {},
      rAdd: {
        model: [
          {
            required: true,
            message: "请填写表盘名称",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写表盘名称",
            trigger: "change",
          },
        ],
        dialPos: [
          {
            required: true,
            message: "请填写表盘ID",
            trigger: "change",
          },
        ],
        preset: [
          {
            required: true,
            message: "请选择是否预置表盘",
            trigger: "change",
          },
        ],
        file: [
          {
            required: true,
            message: "请选择上传文件",
            trigger: "change",
          },
        ],
        picture: [
          {
            required: true,
            message: "请选择上传图片",
            trigger: "change",
          },
        ],
      },
      rEdit: {
        name: [
          {
            required: true,
            message: "请填写表盘名称",
            trigger: "change",
          },
        ],
        dialPos: [
          {
            required: true,
            message: "请填写表盘ID",
            trigger: "change",
          },
        ],
        preset: [
          {
            required: true,
            message: "请选择是否预置表盘",
            trigger: "change",
          },
        ],
      },
      dialForm: {
        model: 0,
        name: "",
        dialPos: "",
        file: null,
        picture: null,
        preset: "0",
      },
      modelList: [
        {
          name: "Y001S",
          value: 0,
        },
        {
          name: "Y006",
          value: 1,
        },
        {
          value: 2,
          name: "Y908S",
        },
        {
          value: 3,
          name: "Y007",
        },
        {
          value: 4,
          name: "Y003",
        },
      ],
      formLabelWidth: "100px",
      submitData: new FormData(),
    };
  },
};
</script>

<style scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.fileUpload /deep/ .el-upload-dragger {
  height: 145px;
}
.fileUpload /deep/ .el-upload-dragger .el-icon-upload {
  margin: 20px 0;
}
.fileUpload /deep/ .el-upload-list__item:first-child {
  margin-top: 0;
}
.fileUpload /deep/ .el-form-item__content {
  line-height: 0;
}
</style>
